import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/kindle-settings-desktop.png'
import _imports_1 from '@/assets.app/images/kindle-settings-mobile.png'


const _hoisted_1 = { class: "container popup__flex-box" }
const _hoisted_2 = { class: "popup__close" }


export default /*@__PURE__*/_defineComponent({
  __name: 'KindleScreenshotPopup',
  props: {
    show: { type: Boolean }
  },
  emits: ["toggleShow"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "popup v-fade",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleShow')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "book-export__popup-content popup__content",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleShow')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "popup__close-icon iconfont iclose-thin" }, null, -1)
          ]))])
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div><h2 class=\"popup__title book-export__popup-title\"> Kindle settings integration </h2><div class=\"book-export__image-wrapper\"><img class=\"book-export__settings-screenshot\" src=\"" + _imports_0 + "\"></div><div class=\"book-export__image-wrapper\"><img class=\"book-export__settings-screenshot-mobile\" src=\"" + _imports_1 + "\"></div></div>", 1))
      ])
    ])
  ], 512)), [
    [_vShow, __props.show]
  ])
}
}

})